const root = "Footer-module_root_dw8Qprgd";
const content = "Footer-module_content_nfdVthfJ";
const section = "Footer-module_section_s57Kd2li";
const list = "Footer-module_list_JLDpelhX";
const resourceLink = "Footer-module_resourceLink_iR9M2xlZ";
const legalLink = "Footer-module_legalLink_ihZscHLn";
const social = "Footer-module_social_ZOmArTUH";
const socialLabel = "Footer-module_socialLabel_q3dVacIO";
const socialList = "Footer-module_socialList_-cfdcwQT";
const socialLink = "Footer-module_socialLink_9CTOD6xT";
const socialIcon = "Footer-module_socialIcon_ro3FzoVh";
const legal = "Footer-module_legal_Xnhk3YWo";
const logo = "Footer-module_logo_Shi6M7tj";
const styles = {
  root,
  content,
  section,
  list,
  resourceLink,
  legalLink,
  social,
  socialLabel,
  socialList,
  socialLink,
  socialIcon,
  legal,
  logo
};
export {
  content,
  styles as default,
  legal,
  legalLink,
  list,
  logo,
  resourceLink,
  root,
  section,
  social,
  socialIcon,
  socialLabel,
  socialLink,
  socialList
};
